/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, TouchableOpacity, StyleSheet, Dimensions } from 'react-native';
import { useSelector } from 'react-redux';
import { isWeb } from '@global/screens';
import { handleTaskCode, parseDate, currency } from '@global/helpers';
import { translateNotificationTitle } from '@global/notificationTemplates';
import Colors from '@/global/colors';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const photoSize = 22;
const notifIconContainer = 35;
const defaultPhoto = require('@/assets/img/default/user-default.png');

const dimension = Dimensions.get('window');

const NotificationItem = ({
  item = {},
  isList = false,
  isDashboard = false,
  onPress,
}) => {
  const currentLanguage = useSelector((state) => state.language.selected);
  const displayTitle = translateNotificationTitle(item, currentLanguage);

  const isNotif = (item) => {
    return ['approved', 'rejected'].includes(item.verb);
  };

  const isNeedApproval = (item) => {
    return item.current_state == 'need_approval';
  };

  const onClick = (item) => {
    try {
      if (!isNotif(item) || isNeedApproval(item)) {
        onPress(item);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  return (
    <TouchableOpacity
      activeOpacity={isNotif(item) ? 1 : 0.6}
      style={{
        paddingHorizontal: 10,
        paddingVertical: 15,
        borderBottomWidth: 1,
        borderBottomColor: Colors.grey0,
        flexDirection: 'row',
        alignItems: isNotif(item) ? 'center' : 'flex-start',
      }}
      onPress={() => onClick(item)}>
      {
        // Notification
        isNotif(item) ? (
          <>
            <View style={styles.icon}>
              <Image
                source={
                  item.verb == 'approved'
                    ? require('@/assets/img/icons/notification/notification-approve.svg')
                    : require('@/assets/img/icons/notification/notification-reject.svg')
                }
                style={styles.icon}
                width={notifIconContainer}
                height={notifIconContainer}
                svg={true}
              />
            </View>
            <View
              style={[
                styles.content,
                isWeb && isList ? styles.contentList : {},
              ]}>
              <View>
                <SociollaText
                  style={[styles.title, isList ? { marginBottom: 0 } : {}]}>
                  {displayTitle}
                </SociollaText>
              </View>
              {item.created_at ? (
                <View>
                  <SociollaText style={[styles.date, { textAlign: 'right' }]}>
                    {parseDate(item.created_at, 'd MMMM yyyy, HH:mm')}
                  </SociollaText>
                </View>
              ) : (
                false
              )}
            </View>
          </>
        ) : (
          // Tasks
          <>
            <View
              style={{
                width: 30,
                borderRadius: 4,
                paddingVertical: 4,
                paddingHorizontal: 4,
                margin: 2,
                backgroundColor: handleTaskCode(
                  item.target_type || (item.target && item.target.entity),
                ).color,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <SociollaText style={{ fontSize: 10 }}>
                {
                  handleTaskCode(
                    item.target_type || (item.target && item.target.entity),
                  ).code
                }
              </SociollaText>
            </View>
            {isDashboard ? (
              <View style={styles.dashBox}>
                <View>
                  {item.created_at && !isWeb ? (
                    <SociollaText style={[styles.date, styles.dashDate]}>
                      {parseDate(item.created_at, 'd MMMM yyyy, HH:mm')}
                    </SociollaText>
                  ) : (
                    false
                  )}
                  <SociollaText
                    style={[
                      styles.title,
                      isList && (isNotif(item) || isWeb)
                        ? { marginBottom: 0, width: 250 }
                        : { width: '100%' },
                    ]}>
                    {displayTitle}
                  </SociollaText>
                  {item?.target_type == 'orders' ? (
                    <View>
                      <SociollaText
                        style={[
                          styles.title,
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        {`${
                          item.object?.sales_team?.name
                            ? item.object.sales_team.name
                            : '-'
                        } (${
                          item.object?.sales_team?.branch_code
                            ? item.object.sales_team.branch_code
                            : '-'
                        })`}
                      </SociollaText>
                      <SociollaText
                        style={[
                          styles.title,
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        {`${
                          item.object?.customer?.name
                            ? item.object.customer.name
                            : '-'
                        } (${
                          item.object?.customer?.code
                            ? item.object.customer.code
                            : '-'
                        })`}
                      </SociollaText>
                    </View>
                  ) : (
                    false
                  )}
                  {item?.target_type == 'skp-externals' ? (
                    <View>
                      <SociollaText
                        style={[
                          styles.title,
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        SKP Number: {item.object?.reference_code}
                      </SociollaText>
                      <SociollaText
                        style={[
                          styles.title,
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        Customer Name: {item.object?.customer?.name}
                      </SociollaText>
                      {item?.object?.outlet ? (
                        <SociollaText
                          style={[
                            styles.title,
                            isList && isWeb ? { marginBottom: 0 } : {},
                          ]}>
                          Outlet Name: {item.object?.outlet?.name}
                        </SociollaText>
                      ) : (
                        false
                      )}
                    </View>
                  ) : (
                    false
                  )}
                  {item?.target_type == 'request-product-tester' ? (
                    <View>
                      <SociollaText
                        style={[
                          styles.title,
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        {item.object?.customer?.name}
                      </SociollaText>
                    </View>
                  ) : (
                    false
                  )}
                </View>
                <View>
                  {item.created_at && isWeb ? (
                    <SociollaText style={[styles.date, styles.dashDate]}>
                      {parseDate(item.created_at, 'd MMMM yyyy, HH:mm')}
                    </SociollaText>
                  ) : (
                    false
                  )}
                  {item?.target_type == 'orders' ? (
                    <View
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                      }}>
                      <View style={{ flexDirection: 'row' }}>
                        <SociollaText
                          type={'bold'}
                          style={[
                            styles.title,
                            isList && isWeb ? { marginBottom: 0 } : {},
                          ]}>
                          Total:
                        </SociollaText>
                        <SociollaText
                          style={[
                            styles.title,
                            { marginLeft: 5 },
                            isList && isWeb ? { marginBottom: 0 } : {},
                          ]}>
                          {currency(item.object?.total_amount || '0', true)}
                        </SociollaText>
                      </View>
                    </View>
                  ) : (
                    false
                  )}
                  <SociollaText
                    type={'bold'}
                    style={[
                      styles.title,
                      isList && isWeb ? { marginBottom: 0 } : {},
                    ]}>
                    {item.object?.status == 'need_approval'
                      ? 'Need Approval'
                      : '-'}
                  </SociollaText>
                </View>
              </View>
            ) : (
              <View
                style={[
                  styles.content,
                  isWeb && isList
                    ? styles.contentList
                    : !isWeb
                    ? { width: dimension.width - 60 }
                    : {},
                ]}>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}>
                  <SociollaText
                    style={[
                      styles.title,
                      isList && (isNotif(item) || isWeb)
                        ? { marginBottom: 0, width: 500 }
                        : { width: 180 },
                    ]}>
                    {displayTitle}
                  </SociollaText>
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                    <View
                      style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        ...(isWeb && isList ? { marginRight: 15 } : {}),
                        ...(isWeb && isList
                          ? { justifyContent: 'space-between' }
                          : {}),
                      }}>
                      {item.created_by && item.created_by.name ? (
                        <>
                          <View
                            style={{
                              borderRadius: 30,
                              backgroundColor: Colors.grey0,
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginRight: 5,
                              overflow: 'hidden',
                              width: photoSize,
                              height: photoSize,
                            }}>
                            <Image
                              source={item.created_by.image}
                              style={{ width: photoSize, height: photoSize }}
                              width={photoSize}
                              height={photoSize}
                              defaultSource={defaultPhoto}
                              isPhoto={true}
                            />
                          </View>
                          <SociollaText style={{ fontSize: 11 }}>
                            {item.created_by.name}
                          </SociollaText>
                        </>
                      ) : (
                        false
                      )}
                    </View>
                    {item.created_at ? (
                      <SociollaText style={styles.date}>
                        {parseDate(item.created_at, 'd MMMM yyyy, HH:mm')}
                      </SociollaText>
                    ) : (
                      false
                    )}
                  </View>
                </View>
                {item.verb === 'mentioned' && item.object?.entity_ref ? (
                  <SociollaText
                    style={[
                      styles.title,
                      isList && isWeb ? { marginBottom: 0 } : {},
                    ]}>
                    {item.object?.entity_label || 'Reference'} ID: #
                    {item.object.entity_ref}
                  </SociollaText>
                ) : (
                  false
                )}
                {item?.target_type == 'orders' ? (
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}>
                    <SociollaText
                      style={[
                        styles.title,
                        isList && isWeb ? { marginBottom: 0 } : {},
                      ]}>
                      {`${
                        item.object?.sales_team?.name
                          ? item.object.sales_team.name
                          : '-'
                      } (${
                        item.object?.sales_team?.branch_code
                          ? item.object.sales_team.branch_code
                          : '-'
                      })`}
                    </SociollaText>
                    <View style={{ flexDirection: 'row' }}>
                      <SociollaText
                        type={'bold'}
                        style={[
                          styles.title,
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        Total:
                      </SociollaText>
                      <SociollaText
                        style={[
                          styles.title,
                          { marginLeft: 5 },
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        {currency(item.object?.total_amount || '0', true)}
                      </SociollaText>
                    </View>
                  </View>
                ) : (
                  false
                )}
                {item?.target_type == 'orders' ? (
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}>
                    <SociollaText
                      style={[
                        styles.title,
                        isList && isWeb ? { marginBottom: 0 } : {},
                      ]}>
                      {`${
                        item.object?.customer?.name
                          ? item.object.customer.name
                          : '-'
                      } (${
                        item.object?.customer?.code
                          ? item.object.customer.code
                          : '-'
                      })`}
                    </SociollaText>
                    <SociollaText
                      type={'bold'}
                      style={[
                        styles.title,
                        isList && isWeb ? { marginBottom: 0 } : {},
                      ]}>
                      {item.object?.status == 'need_approval'
                        ? 'Need Approval'
                        : '-'}
                    </SociollaText>
                  </View>
                ) : (
                  false
                )}
                {item?.target_type == 'skp-externals' ? (
                  <View>
                    <SociollaText
                      style={[
                        styles.title,
                        isList && isWeb ? { marginBottom: 0 } : {},
                      ]}>
                      SKP Number: {item.object?.reference_code}
                    </SociollaText>
                    <SociollaText
                      style={[
                        styles.title,
                        isList && isWeb ? { marginBottom: 0 } : {},
                      ]}>
                      Customer Name: {item.object?.customer?.name}
                    </SociollaText>
                    {item?.object?.outlet ? (
                      <SociollaText
                        style={[
                          styles.title,
                          isList && isWeb ? { marginBottom: 0 } : {},
                        ]}>
                        Outlet Name: {item.object?.outlet?.name}
                      </SociollaText>
                    ) : (
                      false
                    )}
                  </View>
                ) : (
                  false
                )}
                {item?.target_type == 'request-product-tester' ? (
                  <View>
                    <SociollaText
                      style={[
                        styles.title,
                        isList && isWeb ? { marginBottom: 0 } : {},
                      ]}>
                      {item.object?.customer?.name}
                    </SociollaText>
                  </View>
                ) : (
                  false
                )}
              </View>
            )}
          </>
        )
      }
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  content: isWeb
    ? {
        width: 'calc(100% - 35px)',
        paddingLeft: 10,
        display: 'block',
      }
    : {
        width: dimension.width - 60,
        paddingLeft: 10,
      },
  contentList: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 13,
    marginBottom: 5,
  },
  icon: {
    width: notifIconContainer,
    height: notifIconContainer,
  },
  date: {
    fontSize: 11,
    color: Colors.grey1,
  },
  dashBox: {
    width: '90%',
    marginLeft: 8,
    justifyContent: 'space-between',
    flexDirection: !isWeb ? 'column' : 'row',
  },
  dashDate: {
    marginBottom: 5,
  },
});

export default NotificationItem;
